// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerPropertyAddressRentZestimateWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate,
  RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { PropertyAddressRentZestimateResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

interface RentZestimateParams {
  fullAddress: string;
  unit?: string;
}

export type RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_Options = UseQueryOptions<
  PropertyAddressRentZestimateResponseWebDto,
  unknown,
  PropertyAddressRentZestimateResponseWebDto,
  readonly [string, RentZestimateParams]
>;

const RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_GetKey = (getParams: RentZestimateParams) =>
  [RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_Path, getParams] as const;

export const RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_queryOptions = (
  getParams: RentZestimateParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_GetKey(getParams),
    queryFn: () => RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get rent zestimate for an address for non authenticated users
 */
export const useRentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate = (
  getParams: RentZestimateParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate.getKey =
  RentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate_GetKey;
